import { DEFAULT_AXES } from '../constants'
import { populateArrayWithAlphaValues } from '../utils'

export default function useDonut (input: Array<any> | undefined, options?) {
  return () => {
    const data = input?.map((point, index, array: Array<any>) => ({
        'group': point.group,
        'value': point.value
      }))
  // if (stringArray.length != valueArray.length) { return null }
  // else {
  //   const tempArr: Array<Dictionary<any>> = []
  //   for (let i=0; i<stringArray.length; i++) {
  //     tempArr.push({
  //       'group': stringArray[i],
  //       'value': valueArray[i]
  //     })
  //   }
  //   return tempArr
  // }
  return {
    data,
  options: {
    axes: DEFAULT_AXES,
    resizable: true,
    height: '300px',
    legend: {
        alignment: 'center'
      },
      donut: {
        alignment: 'center'
      },
      color: {
        scale: options?.scale || []
      }
    }
  }
  }
}

